module.exports = __webpack_public_path__ + "media/icons/widget-download-google-play-2b2b3cef.png";